






























































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { fetchEdicionCertificados } from './fetchEdicionCertificados';
const { AgGridVue } = require('ag-grid-vue');
export type MsgParam = { msg: string };

@Component({
  components: {
    GridComponent: AgGridVue,
  },
})
export default class CertificadosModalEmitir extends Vue {
  @Prop({ default: true }) show: boolean;
  readonly funcionalidad: Funcionalidades = null;
  readonly accionesTotales: PermisoAccion[] = [];
  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify = null;
  cert = {
    tipo: '',
    patente: '',
    observaciones: '',
  };
  dialog: boolean = true;
  timeout: { timeout: number } = { timeout: 3000 };
  filter: any = [];
  rutaAlPdf: string = '';
  urlDescarga: string = '';
  nombreArchivo: string = '';
  constructor() {
    super();
  }
  mounted() {
    this.get_tipo_certificados();
  }

  handleClosed(): void {
    this.$emit('cerrar');
  }
  emitirCertificado() {
    this.loadingService.showLoading();
    const self = this;
    if (!(this.$refs.form as any).validate()) {
      this.$snotify.error('Por favor, corrija los errores en el formulario', {
        ...this.timeout,
      });
      self.loadingService.hideLoading();
      return;
    }
    if (this.cert.tipo == '') {
      self.$snotify.error('Debe seleccionar un tipo de certificado', {
        ...self.timeout,
      });
      self.loadingService.hideLoading();
      return;
    }
    if (this.cert.patente == '') {
      self.$snotify.error('Debe ingresar una patente', { ...self.timeout });
      self.loadingService.hideLoading();
      return;
    }
    fetchEdicionCertificados({
      serviceClient: 'certificados',
      endpoint: 'generatePDF',
      body: {
        tipo: this.cert.tipo,
        patente: this.cert.patente,
        front: true,
        observaciones: this.cert.observaciones,
      },
    })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, url } = response.data;
        console.log(response.data);
        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { ...self.timeout });
        } else {
          self.$snotify.success('Certificado emitido correctamente', {
            ...self.timeout,
          });
          this.rutaAlPdf = url;
          this.urlDescarga = url;
          this.nombreArchivo = 'certificado_' + this.cert.patente + '.pdf';

          // self.handleClosed();
        }
      })
      .catch((err: Error) => {
        err instanceof Error && self.validateError({ msg: err.message });
        throw err;
      })
      .finally(() => self.loadingService.hideLoading());
  }

  async get_tipo_certificados() {
    this.loadingService.showLoading();
    const self = this;
    await fetchEdicionCertificados({
      endpoint: 'get_tipo_certificados',
      body: {},
    })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;
        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { ...self.timeout });
          this.filter = [];
        }
        this.filter = LISTA;
      })
      .catch((err: Error) => {
        err instanceof Error && self.validateError({ msg: err.message });
        throw err;
      })
      .finally(() => self.loadingService.hideLoading());
  }

  validateError({ msg }: MsgParam): void {
    if (msg === 'Request failed with status code 500') {
      this.$snotify.error(
        'El servicio no se encuentra disponible, por favor intente más tarde',
        { ...this.timeout }
      );
    } else {
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { ...this.timeout }
      );
    }
    throw msg;
  }
}
